import React from 'react';
import styles from '../../styles/components/question-flow/QuestionFlowHeader.module.css';

export interface FlowHeaderProps {
  title: string;
  subtitle: string | null;
}

const QuestionFlowHeader: React.FC<FlowHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    </div>
  );
};

export default QuestionFlowHeader;
